import 'zone.js';

import { context } from '@opentelemetry/api';
import { ZoneContextManager } from '@opentelemetry/context-zone-peer-dep';
import { initBrowserTelemetry } from '@parrot-software/observability/browser';
import { createConsoleExporter } from '@parrot-software/observability/exporters/console';
import { createSameOriginExporter } from '@parrot-software/observability/exporters/same-origin';

// Register ZoneContextManager BEFORE initBrowserTelemetry so async context propagation works.
// OTEL only accepts the first context manager registered.
context.setGlobalContextManager(new ZoneContextManager().enable());

const isDev = process.env.REACT_APP_OTEL_ENVIRONMENT === 'development';

initBrowserTelemetry({
  serviceName: 'parrot-connect-web',
  environment: process.env.REACT_APP_OTEL_ENVIRONMENT,
  version: process.env.REACT_APP_VERSION,
  exporter: isDev ? createConsoleExporter() : createSameOriginExporter(),
  propagationOrigins: [
    /api(-staging)?\.parrot\.rest/,
    /pay-api(-staging)?\.parrot\.rest/,
    /inventory-api(-staging)?\.parrot\.rest/,
    /localhost:\d+/,
  ],
  routeDomainMapping: {
    '/onboarding': 'ONB',
    '/personnel': 'PER',
    '/employees': 'PER',
    '/reports': 'REP',
    '/subscription': 'SUB',
    '/subscriptions': 'SUB',
    '/compliance': 'LGL',
    '/users': 'IAM',
    '/auth': 'IAM',
    '/verify-account': 'IAM',
    '/profile': 'IAM',
    '/inventories': 'INV',
    '/catalog': 'CAT',
    '/orders': 'ORD',
    '/payments': 'PAY',
  },
  webVitals: true,
  pageViews: true,
  errorHandler: true,
});
